import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useDocumentCategoriesSettings() {
  const {
    tours: {
      AccountingSettings: { DocumentCategories },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: DocumentCategories.Title,
      steps: [
        {
          content: DocumentCategories.Step1.Text,
          placement: 'auto',
          target: '#documentCategories',
          title: DocumentCategories.Step1.Title,
          disableBeacon: true,
          link: DocumentCategories.Step1.DetailsLink,
        },
        {
          content: DocumentCategories.Step2.Text,
          placement: 'auto',
          target: '#categoryList',
          title: DocumentCategories.Step2.Title,
          disableBeacon: true,
          link: DocumentCategories.Step2.DetailsLink,
        },
        {
          content: DocumentCategories.Step3.Text,
          placement: 'right',
          target: '#addItemButton',
          title: DocumentCategories.Step3.Title,
          disableBeacon: true,
          link: DocumentCategories.Step3.DetailsLink,
        },
        {
          content: DocumentCategories.Step4.Text,
          placement: 'auto',
          target: '#documentTypes',
          title: DocumentCategories.Step4.Title,
          disableBeacon: true,
          link: DocumentCategories.Step4.DetailsLink,
        },
        {
          content: DocumentCategories.Step5.Text,
          placement: 'auto',
          target: '#typeName',
          title: DocumentCategories.Step5.Title,
          disableBeacon: true,
          link: DocumentCategories.Step5.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-10px',
              marginLeft: '-10px',
            },
          },
        },
        {
          content: DocumentCategories.Step6.Text,
          placement: 'top',
          target: '#removalCount',
          title: DocumentCategories.Step6.Title,
          disableBeacon: true,
          link: DocumentCategories.Step6.DetailsLink,
          styles: {
            spotlight: {
              marginTop: '-10px',
            },
          },
        },
        {
          content: DocumentCategories.Step7.Text,
          placement: 'auto',
          target: '#removalDateType',
          title: DocumentCategories.Step7.Title,
          disableBeacon: true,
          link: DocumentCategories.Step7.DetailsLink,
        },
        {
          content: DocumentCategories.Step8.Text,
          placement: 'auto',
          target: '#typeCrud',
          title: DocumentCategories.Step8.Title,
          disableBeacon: true,
          link: DocumentCategories.Step8.DetailsLink,
        },
      ],
    }),
    [DocumentCategories],
  );

  return [pageTour];
}
